export const state = () => ({
    group: "faq",
    version: "faq",
    path: "frequently-asked-questions",
    query: "",
    products: [],
});

export const mutations = {
    setProducts(state, page) {
        let products = [];

        if (page) {
            page.version.data.forEach((section) => {
                products.push({
                    name: section.data.title,
                    aliases: {},
                    questions: section.data.segments.map((question) => {
                        return {
                            dataId: question.data.id,
                            id: question.data.link,
                            title: question.data.question,
                            answer: question.data.answer,
                        };
                    }),
                });
            });
        }

        state.products = products;
    },

    setQuery(state, query) {
        state.query = query;
    },
};

export const actions = {
    async fetchPage(context) {
        const currentLocale = () => {
            return this.$i18n.locales.find((l) => l.code == this.$i18n.locale);
        };

        try {
            let { data } = await this.$adminApi.get(
                "/page/" + context.state.group + "/" + context.state.version + "/" + context.state.path + "?lang=" + currentLocale().iso
            );
            context.commit("setProducts", data.page);
        } catch (error) {
            console.log("Failed to fetch handbook pages: " + error);
            throw error;
        }
    },
};

export const getters = {
    getProductResults(state) {
        if (state.query.length > 1) {
            return state.products.map((product) => {
                let words = state.query
                    .trim()
                    .replace(/[!-\/:-@[-`{-~]/g, "")
                    .split(/\s/g);
                let aliases = [];

                // Add aliases to query
                for (const alias in product.aliases) {
                    const regex = RegExp(product.aliases[alias].join("|"), "ig");

                    if (regex.test(query.trim())) {
                        words.push(alias);
                        aliases.push(alias);
                    }
                }

                const regex = RegExp(words.join("|"), "ig");

                return {
                    ...product,
                    questions: product.questions.reduce((questions, question) => {
                        const match = (string) => {
                            const matches = new Set();
                            const matched = string.replace(regex, (match) => {
                                matches.add(match.toLowerCase());
                                return match;
                            });

                            return matches.size == words.length || (matches.size && aliases.length) ? matched : false; // Don't include in results unless all words are matched
                        };

                        const title = match(question.title);
                        const answer = match(question.answer);

                        if (title || answer) {
                            questions.push({
                                ...question,
                                title: title || question.title,
                                answer: answer || question.answer,
                            });
                        }

                        return questions;
                    }, []),
                };
            });
        }

        return state.products;
    },
};
